// extracted by mini-css-extract-plugin
export default {"base":"Footer_base__7Qzzu","inner":"Footer_inner__sOpJ9","navigation":"Footer_navigation__o5zz+","link":"Footer_link__DcRTw"};